import Event from '../../core/Event';
import { Products } from '../State';

export default class OrderProductsReceived extends Event {
    public static type = 'OrderProductsReceived';

    constructor(public readonly products: Products) {
        super(OrderProductsReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderProductsReceived.ts